// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.png";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import angular from "./assets/techstack/angular.png";
import vscode from "./assets/techstack/vscode.png";
import visualstudio from "./assets/techstack/visualstudio.png";
import github from "./assets/techstack/github.png";
import postman from "./assets/techstack/postman.png";
import csharp from "./assets/techstack/csharp.png";
import maui from "./assets/techstack/maui.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";


// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Quentin Dessere",
  tagline: "Welcome to my website",
  img: profile,
  about: `My name is Quentin Dessere, and I’m a web and mobile app developer. I enjoy creating functional and modern projects, and I love turning ideas into real solutions..`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
    linkdein: "https://www.linkedin.com/in/quentin-dessere-36aa8311a/",
    github: "https://github.com/DessereQuentin",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Frontend Web Developer",
    Company: `Allianz`,
    Location: "Paris -La Défense",
    Type: "Full Time",
    Duration: "Nov 2021 - Apr 2024",
  }, 
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Web Developer",
    Company: "Openclassrooms",
    Location: "Online",
    Type: "Full Time",
    Duration: "Mar 2022 - Sep 2022",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  csharp: csharp,
  maui: maui,
  react: react,
  angular:angular,  
  sass: sass,    
  vscode: vscode,
  visualstudio: visualstudio,
  postman: postman,  
  github: github, 
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "QRDess Free",
    image: projectImage1,
    description: `Mobile application for reading and creating custom QR codes`,
    techstack: "C#,Maui",
        previewLink: null,                
        githubLink: null,
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "quentin.dessere@outlook.fr",
};
